import { api } from '@/lib/api'
import type { ApprovalRequest, ApprovalStatus } from '@riverpark/types'

export async function listApprovals(status?: ApprovalStatus) {
  const qs = status ? `?status=${status}` : ''
  return api.get<{ data: ApprovalRequest[] }>(`/approvals${qs}`)
}

export async function getApproval(id: string) {
  return api.get<{ data: ApprovalRequest }>(`/approvals/${id}`)
}

export async function approveRequest(id: string, note?: string) {
  return api.post<{ data: ApprovalRequest }>(`/approvals/${id}/approve`, { note })
}

export async function rejectRequest(id: string, note: string) {
  return api.post<{ data: ApprovalRequest }>(`/approvals/${id}/reject`, { note })
}
